<div class="card">
  <div class="card-body">
    @if (details(); as details) {
      <div class="row">
        <div class="d-flex justify-content-between">
          <h4>{{ 'pages.transport.detail-page.contents.headline' | translate }}</h4>
          <div class="d-flex flex-row align-items-center">
            <p-button
              icon="pi pi-angle-up"
              (onClick)="toggleComponentCollapse()"
              class="collapse-arrow"
              [class.collapsed]="isComponentCollapsed()"
              [rounded]="true"
              size="large"
              variant="text"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-4 col-lg-3 border-md-end mt--24">
          <div class="d-flex flex-column">
            <myarvato-data-field
              [label]="'pages.transport.detail-page.contents.positions' | translate"
              [hideWhenEmpty]="false"
              [data]="details.contents.contentItems.length"
            />
          </div>
        </div>

        <div class="col-12 col-md-4 col-lg-3 border-md-end mt--24">
          <div class="d-flex flex-column ml-md--16">
            <myarvato-data-field
              [label]="'pages.transport.detail-page.contents.quantity' | translate"
              [hideWhenEmpty]="false"
              [data]="totalQuantity()"
            />
          </div>
        </div>

        <div class="col-12 col-md-4 col-lg-3 border-md-end mt--24">
          <div class="d-flex flex-column ml-md--16">
            <myarvato-data-field
              [hideWhenEmpty]="false"
              [label]="'pages.transport.detail-page.contents.weight' | translate"
              [data]="details.contents.totalWeight + ' ' + details.contents.totalWeightUnit"
            />
          </div>
        </div>

        <div class="col-12 col-md-4 col-lg-3 mt--24">
          <div class="d-flex flex-column ml-md--16">
            <myarvato-data-field
              [label]="'pages.transport.detail-page.contents.dimensions' | translate"
              [hideWhenEmpty]="true"
              [data]="details.contents.size"
            />
          </div>
        </div>
      </div>

      @if (!isComponentCollapsed()) {
        <div class="mt--24" @collapseAnimation>
          <p-table
            [value]="details.contents.contentItems"
            [paginator]="needsPagination()"
            [rowsPerPageOptions]="[5, 10, 20]"
            [savePageSize]="'transport-details-contents-table'"
          >
            <ng-template #header>
              <tr>
                <th scope="col">{{ 'pages.transport.detail-page.contents.item-name' | translate }}</th>
                <th scope="col">{{ 'pages.transport.detail-page.contents.material-id' | translate }}</th>
                <th scope="col">{{ 'pages.transport.detail-page.contents.units' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template #body let-item>
              <tr>
                <td>{{ item.description }}</td>
                <td>{{ item.id }}</td>
                <td class="bold">{{ item.amount }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
    }
  </div>
</div>
